<template>
  <div
    class="pa-6"
  >
    <v-row>
      <v-spacer />
      <v-col cols="auto">
        <v-btn
          text
          color="primary"
          class="text-none"
          @click="newNote.dialog = true"
        >
          <v-icon
            x-small
            left
          >
            far fa-plus
          </v-icon>
          {{ $t('button.add_note') }}
        </v-btn>
      </v-col>
    </v-row>

    <div v-if="!event.notes || event.notes.length === 0">
      <div class="text-center title grey--text mt-10">
        <div>
          <v-icon
            x-large
            class="grey--text text--lighten-2"
          >
            fal fa-notes
          </v-icon>
        </div>
        <div class="mt-3">
          {{ $t('notes_empty') }}
        </div>
      </div>
    </div>
    <div
      v-else
      class="mb-16"
    >
      <player-note
        v-for="note in event.notes"
        :key="note.id"
        :note="note"
        :has-visible-by-player-option="true"
        :has-pinned-option="!(note.players && note.players.length > 0)"
        :can-edit="$can('edit-event-notes')"
        :can-delete="$can('delete-event-notes')"
        show-player-name
        class="mb-3"
        @update="$emit('update')"
      />
    </div>

    <card-dialog
      v-model="newNote.dialog"
      :title="$t('add_note.dialog.header')"
      max-width="800px"
    >
      <validation-observer ref="noteValidationObserver">
        <validation-provider
          v-slot="{ errors }"
          rules="required"
        >
          <rich-text-editor
            v-model="newNote.text"
            class="white"
            placeholder="Enter event note"
          />
          <div
            v-if="errors.length > 0"
            class="caption error--text"
          >
            {{ errors[0] }}
          </div>
          <div class="pa-2">
            <v-row
              no-gutters
              align="center"
            >
              <v-col
                cols="auto"
              >
                <v-switch
                  v-model="newNote.isPlayerVisible"
                  :label="$t('switch.visible_to_player') "
                  dense
                  hide-details
                  class="pa-0 ma-0"
                />
              </v-col>
              <v-col
                cols="auto"
                class="pl-3"
              >
                <v-switch
                  v-model="newNote.isPinned"
                  :label="$t('switch.pinned')"
                  hide-details
                  dense
                  class="pa-0 ma-0"
                />
              </v-col>
            </v-row>
          </div>
        </validation-provider>
      </validation-observer>

      <template v-slot:actions>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            :loading="newNote.submitting"
            @click="submit()"
          >
            {{ $t('training_builder.button.save') }}
          </v-btn>
        </v-card-actions>
      </template>
    </card-dialog>
  </div>
</template>

<script>

import CardDialog from '@/components/helpers/CardDialog.vue'
import RichTextEditor from '@/components/inputs/RichTextEditor.vue'
import PlayerNote from '@/components/players/PlayerNote.vue'
import { EventApiService } from '@/data/services'

export default {
  name: 'EventNotes',
  components: {
    PlayerNote,
    RichTextEditor,
    CardDialog
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    newNote: {
      dialog: false,
      text: '',
      isPlayerVisible: false,
      isPinned: false,
      submitting: false
    }
  }),
  watch: {
    'newNote.dialog': function (value) {
      if (value) {
        this.newNote.text = ''
        this.newNote.isPlayerVisible = false
        this.newNote.isPinned = false
      }
    }
  },
  created() {
  },
  methods: {
    async submit() {
      if (!(await this.$refs.noteValidationObserver.validate())) return

      await this.save()
    },
    async save() {
      this.newNote.submitting = true

      try {
        await EventApiService.submitNote(this.event.id, {
          text: this.newNote.text,
          is_pinned: this.newNote.isPinned,
          is_player_visible: this.newNote.isPlayerVisible
        })

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.note_save.success'),
          color: 'success'
        })

        this.newNote.text = ''
        this.newNote.isPinned = false
        this.newNote.isPlayerVisible = false

        this.$refs.noteValidationObserver.reset()

        this.newNote.dialog = false

        this.$emit('update')
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.note_save.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.newNote.submitting = false
      }
    }
  }
}
</script>
